import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaTimes, FaUserShield } from 'react-icons/fa';
import API_BASE_URL from '../config';
import "./Registration.css";

const Registration = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
        mobile: '',
        address: '',
        company_name: '',
        designation: '',
        username: '', // Username now placed right above password fields
        password: '',
        confirm_password: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirm_password) {
            alert("Passwords do not match! Please check again.");
            return;
        }

        setLoading(true);

        try {
            const { confirm_password, ...payload } = formData;

            const response = await fetch(`${API_BASE_URL}/auth/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                alert(
                    "Your Registration is Complete!\n" + 
                    "Please Contact Admin for your approval."
                );
                navigate('/login');
            } else {
                alert(data.message || "Registration failed. Username or Email might already exist.");
            }
        } catch (err) {
            console.error("Registration Error:", err);
            alert("Could not connect to the server. Please check your internet or server status.");
        } finally {
            setLoading(false);
        }
    };

    return (
            <div className="reg-page-container">
                <div className="reg-modal-box">
                    <div className="reg-modal-header">
                        <div className="reg-header-title-area">
                            <div className="reg-top-icon">
                                <FaUserShield />
                            </div>
                            <h2 className="reg-heading">n-tools Account Registration</h2>
                        </div>
                        <button className="reg-close-btn" onClick={() => navigate('/login')} title="Close">
                            <FaTimes />
                        </button>
                    </div>

                <form className="reg-form-content" onSubmit={handleSubmit}>
                    <div className="reg-scrollable-fields">
                        <div className="reg-input-group">
                            <input 
                                type="text" 
                                name="full_name"
                                className="reg-field" 
                                placeholder="Full Name" 
                                value={formData.full_name}
                                onChange={handleChange}
                                required 
                                disabled={loading}
                            />
                        </div>

                        <div className="reg-input-group">
                            <input 
                                type="email" 
                                name="email"
                                className="reg-field" 
                                placeholder="Email" 
                                value={formData.email}
                                onChange={handleChange}
                                required 
                                disabled={loading}
                            />
                        </div>

                        <div className="reg-input-group">
                            <input 
                                type="text" 
                                name="mobile"
                                className="reg-field" 
                                placeholder="Mobile Number" 
                                value={formData.mobile}
                                onChange={handleChange}
                                required 
                                disabled={loading}
                            />
                        </div>

                        <div className="reg-input-group">
                            <input 
                                type="text" 
                                name="address"
                                className="reg-field" 
                                placeholder="Address" 
                                value={formData.address}
                                onChange={handleChange}
                                required 
                                disabled={loading}
                            />
                        </div>

                        <div className="reg-input-group">
                            <input 
                                type="text" 
                                name="company_name"
                                className="reg-field" 
                                placeholder="Company / Organization" 
                                value={formData.company_name}
                                onChange={handleChange}
                                required 
                                disabled={loading}
                            />
                        </div>

                        <div className="reg-input-group">
                            <input 
                                type="text" 
                                name="designation"
                                className="reg-field" 
                                placeholder="Designation / Post" 
                                value={formData.designation}
                                onChange={handleChange}
                                required 
                                disabled={loading}
                            />
                        </div>

                        {/* Username placed right before Password */}
                        <div className="reg-input-group">
                            <input 
                                type="text" 
                                name="username"
                                className="reg-field" 
                                placeholder="Username" 
                                value={formData.username}
                                onChange={handleChange}
                                required 
                                disabled={loading}
                            />
                        </div>
                        
                        <div className="reg-input-group">
                            <div className="reg-pass-container">
                                <input 
                                    name="password"
                                    type={showPassword ? "text" : "password"} 
                                    className="reg-field" 
                                    placeholder="Password" 
                                    value={formData.password}
                                    onChange={handleChange}
                                    required 
                                    disabled={loading}
                                />
                                <span className="reg-eye-icon" onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>

                        <div className="reg-input-group">
                            <div className="reg-pass-container">
                                <input 
                                    name="confirm_password"
                                    type={showConfirmPassword ? "text" : "password"} 
                                    className="reg-field" 
                                    placeholder="Confirm Password" 
                                    value={formData.confirm_password}
                                    onChange={handleChange}
                                    required 
                                    disabled={loading}
                                />
                                <span className="reg-eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="reg-actions">
                        <button type="submit" className="reg-submit-btn" disabled={loading}>
                            {loading ? "Processing..." : "Register Now"}
                        </button>
                        
                        <button type="button" onClick={() => navigate('/login')} className="reg-back-btn" disabled={loading}>
                            Back to Home
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Registration;